import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    EmptyState,
    EmptyStateActions,
    EmptyStateIcon,
    EmptyStateNotFoundHeading,
} from '@gitbook/spine-react';

/**
 * Full-screen component when the content doesn't exist.
 */
export function SpaceContentNotFound(props: { spaceId: string }): React.ReactElement {
    const { spaceId } = props;

    return (
        <EmptyState>
            <EmptyStateIcon>
                <Icon.Space />
            </EmptyStateIcon>
            <EmptyStateNotFoundHeading />
            <Description>
                The content you are trying to access in this space doesn't exist or may have been
                deleted.
            </Description>
            <EmptyStateActions>
                <Button
                    kind="secondary"
                    size="medium"
                    href={{
                        screen: {
                            type: 'space',
                            space: spaceId,
                            revision: undefined,
                            changeRequest: undefined,
                        },
                    }}
                    label="Browse space"
                />
            </EmptyStateActions>
        </EmptyState>
    );
}
